import { Careers, getStaticProps } from 'routes/public/Careers'

export { getStaticProps }

export default Careers
